<template>
  <div id="app" :hasAcceptRGPD="gethasRGPD">
    <app-header v-if="getLogged"></app-header>
    <router-view :logged="getLogged" />
    <app-footer v-if="$route.name != 'login'"></app-footer>
    <popup-encuestas></popup-encuestas>
    <popup-errores></popup-errores>
  </div>
</template>

<script>

  import { mapGetters, mapActions } from 'vuex';

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import CookieLaw from 'vue-cookie-law'

  import popupencuestas from '@/components/parts/popup-encuestas';
  import popuperrores from '@/components/parts/popup-errores';

  import router from '@/router';

  export default {
    name: 'App',
    mounted() {
      this.checkLogged().then(r => {
        if(!r){
          router.push({name: 'logout'})
        }
      });
    },
    components: {
      'app-header': header,
      'app-footer': footer,
      'cookie-law': CookieLaw,
      'popup-encuestas': popupencuestas,
      'popup-errores': popuperrores,
    },
    computed: {
      ...mapGetters(['getLogged','gethasRGPD'])
    },
    methods: {
      ...mapActions(['checkLogged'])
    }
  }
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';
  @import './assets/css/style.scss';
  @import './assets/css/responsive.scss';
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>


// WEBPACK FOOTER //
// src/App.vue